'use client';

import React from 'react';

export default function EmptyChatState() {
  return (
    <div className="flex flex-col items-center justify-center h-full py-20 gap-5 animate-fade-in">
      {/* Dark panel */}
      <div
        className="flex flex-col items-center gap-4 px-8 py-8 text-center max-w-[280px]"
        style={{
          background: 'rgba(27,42,58,0.88)',
          borderRadius: '28px',
          border: '1px solid rgba(255,255,255,0.07)',
          backdropFilter: 'blur(8px)',
        }}
      >
        {/* Illustration */}
        <svg width="72" height="72" viewBox="0 0 72 72" fill="none" aria-hidden="true">
          <circle cx="36" cy="36" r="36" fill="rgba(46,166,255,0.1)" />
          {/* Chat bubbles illustration */}
          <rect x="14" y="20" width="30" height="18" rx="6" fill="none" stroke="#2EA6FF" strokeWidth="1.8"/>
          <polygon points="18,38 15,46 24,38" fill="none" stroke="#2EA6FF" strokeWidth="1.5" strokeLinejoin="round"/>
          <rect x="28" y="34" width="26" height="16" rx="5" fill="rgba(102,80,216,0.3)" stroke="#6650D8" strokeWidth="1.6"/>
          <polygon points="50,50 53,57 44,50" fill="none" stroke="#6650D8" strokeWidth="1.4" strokeLinejoin="round"/>
          {/* Dots in bubbles */}
          <circle cx="22" cy="29" r="1.5" fill="#2EA6FF" opacity="0.7"/>
          <circle cx="29" cy="29" r="1.5" fill="#2EA6FF" opacity="0.7"/>
          <circle cx="36" cy="29" r="1.5" fill="#2EA6FF" opacity="0.7"/>
          <circle cx="37" cy="42" r="1.5" fill="#6650D8" opacity="0.8"/>
          <circle cx="43" cy="42" r="1.5" fill="#6650D8" opacity="0.8"/>
          <circle cx="49" cy="42" r="1.5" fill="#6650D8" opacity="0.8"/>
        </svg>

        <div>
          <p className="text-white font-semibold text-[18px] leading-tight">No messages here yet...</p>
          <p className="text-[14px] mt-2 leading-relaxed" style={{ color: '#91A3B7' }}>
            Send a message or tap<br />the greeting below.
          </p>
        </div>
      </div>
    </div>
  );
}